export default {"src":"/trader-new/_next/static/media/profile-popup.51dfbed4.svg","height":106,"width":106,"blurWidth":0,"blurHeight":0};